import React from 'react';
import Icon from '../../components/AppIcon';
import { Link } from 'react-router-dom';
import TopNavigation from '../../components/TopNavigation';
import Footer from '../../components/Footer';

const DefenseDualUseUseCaseDetail = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TopNavigation />
      
      {/* Hero Section */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Two Column Layout */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
      
      {/* Left Column - Text Content */}
      <div>
        {/* Badge */}
        <div 
          className="inline-flex items-center px-4 py-2 rounded-md text-xs font-bold tracking-wider mb-8"
          style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#E8EDDF' }}
        >
          DEFENSE & DUAL-USE
        </div>
        
        {/* Title */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" style={{ color: '#E8EDDF' }}>
          Orchestrating Distributed Systems Under Pressure
        </h1>
        
        {/* Description */}
        <p className="text-base md:text-lg leading-relaxed mb-10" style={{ color: '#9CA3AF' }}>
          Interoperability across domains, resilience in degraded or contested environments, and digital sovereignty from edge to headquarters—ensuring coordinated action when it matters most.
        </p>
        
        {/* Buttons */}
        <div className="flex flex-wrap gap-4">
          <a 
            href="/contact"
            className="inline-flex items-center justify-center px-6 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#4FB3B8', color: '#242423' }}
          >
            Request a Confidential Briefing
          </a>
          <a 
            href="/use-cases"
            className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg font-semibold text-base transition-colors"
            style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#F5CB5C' }}
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="#F5CB5C" strokeWidth="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            Explore Other Use Cases
          </a>
        </div>
      </div>
      
      {/* Right Column - Diagram */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#242423', border: '2px solid #4FB3B8' }}
      >
        <svg width="100%" height="520" viewBox="0 0 400 520" className="max-w-full">
          
          {/* ===== TOP ROW: 4 DOMAIN ICONS ===== */}
          
          {/* AIR */}
          <circle cx="65" cy="45" r="35" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <g transform="translate(50, 32)">
            <circle cx="8" cy="8" r="5" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M13 4 L18 8 L13 12" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <circle cx="22" cy="8" r="3" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          </g>
          <text x="65" y="100" textAnchor="middle" fill="#4FB3B8" fontSize="11" fontWeight="600">AIR</text>
          
          {/* LAND */}
          <circle cx="155" cy="45" r="35" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <g transform="translate(143, 32)">
            <circle cx="12" cy="8" r="6" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <circle cx="12" cy="8" r="2" fill="#4FB3B8" />
            <circle cx="12" cy="8" r="10" fill="none" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="2 2" />
          </g>
          <text x="155" y="100" textAnchor="middle" fill="#4FB3B8" fontSize="11" fontWeight="600">LAND</text>
          
          {/* SEA */}
          <circle cx="245" cy="45" r="35" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <g transform="translate(235, 32)">
            <path d="M10 5 L5 18 L15 18 Z" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <path d="M10 18 L10 22" stroke="#4FB3B8" strokeWidth="1.5" />
          </g>
          <text x="245" y="100" textAnchor="middle" fill="#4FB3B8" fontSize="11" fontWeight="600">SEA</text>
          
          {/* SENSOR */}
          <circle cx="335" cy="45" r="35" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <g transform="translate(323, 33)">
            <circle cx="12" cy="12" r="8" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <circle cx="12" cy="12" r="3" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
            <circle cx="12" cy="12" r="1" fill="#4FB3B8" />
          </g>
          <text x="335" y="100" textAnchor="middle" fill="#4FB3B8" fontSize="11" fontWeight="600">SENSOR</text>
          
          {/* ===== DASHED LINES CONVERGING ===== */}
          <path d="M65 80 C65 130, 150 150, 200 170" fill="none" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="4 3" />
          <path d="M155 80 C155 130, 180 150, 200 170" fill="none" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="4 3" />
          <path d="M245 80 C245 130, 220 150, 200 170" fill="none" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="4 3" />
          <path d="M335 80 C335 130, 250 150, 200 170" fill="none" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="4 3" />
          
          {/* Convergence dot */}
          <circle cx="200" cy="175" r="5" fill="#4FB3B8" />
          
          {/* Dashed line to SLEEVE box */}
          <line x1="200" y1="180" x2="200" y2="210" stroke="#4FB3B8" strokeWidth="1" strokeDasharray="4 3" />
          
          {/* ===== SLEEVE ORCHESTRATION BOX ===== */}
          <rect x="30" y="215" width="340" height="130" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
          
          {/* Orchestration Icon */}
          <g transform="translate(180, 235)">
            <rect x="0" y="12" width="10" height="10" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <rect x="30" y="12" width="10" height="10" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <rect x="15" y="0" width="10" height="10" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="20" y1="10" x2="20" y2="16" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="5" y1="16" x2="35" y2="16" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="5" y1="16" x2="5" y2="22" stroke="#9CA3AF" strokeWidth="1.5" />
            <line x1="35" y1="16" x2="35" y2="22" stroke="#9CA3AF" strokeWidth="1.5" />
          </g>
          
          <text x="200" y="290" textAnchor="middle" fill="#E8EDDF" fontSize="13" fontWeight="700">SLEEVE ORCHESTRATION</text>
          <text x="200" y="315" textAnchor="middle" fill="#9CA3AF" fontSize="10">Unified coordination layer enabling interoperability, resilience, and</text>
          <text x="200" y="330" textAnchor="middle" fill="#9CA3AF" fontSize="10">autonomous operation across all domains</text>
          
          {/* ===== GAP / EMPTY SPACE ===== */}
          
          {/* ===== COMMAND BOX ===== */}
          <rect x="30" y="400" width="340" height="105" rx="8" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
          
          {/* Users Icon */}
          <g transform="translate(180, 420)">
            <circle cx="20" cy="8" r="7" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <path d="M8 35 C8 22, 14 16, 20 16 C26 16, 32 22, 32 35" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <circle cx="38" cy="10" r="5" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
            <path d="M32 35 C32 25, 35 20, 38 20 C43 20, 48 25, 48 35" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          </g>
          
          <text x="200" y="470" textAnchor="middle" fill="#E8EDDF" fontSize="13" fontWeight="700">COMMAND</text>
          <text x="200" y="492" textAnchor="middle" fill="#9CA3AF" fontSize="10">Human-in-the-Loop Decision Authority</text>
          
        </svg>
      </div>
      
    </div>
    
  </div>
</section>


      {/* The System-of-Systems Challenge */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        The System-of-Systems Challenge
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Modern defense and civil emergencies are not single-platform problems. Success depends on coordinating distributed, heterogeneous assets—not optimizing individual systems in isolation.
      </p>
    </div>
    
    {/* Three Columns - Challenges */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10 text-center">
      
      {/* Heterogeneous Assets */}
      <div>
        <h3 className="text-base font-bold mb-3" style={{ color: '#E8EDDF' }}>Heterogeneous Assets</h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Operations span legacy military hardware, commercial IoT, AI models, and human operators across multiple domains.
        </p>
      </div>
      
      {/* Degraded Communications */}
      <div>
        <h3 className="text-base font-bold mb-3" style={{ color: '#E8EDDF' }}>Degraded Communications</h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Networks may be contested, denied, intermittent, or low-bandwidth. Centralized control alone is fragile.
        </p>
      </div>
      
      {/* Mission Continuity */}
      <div>
        <h3 className="text-base font-bold mb-3" style={{ color: '#E8EDDF' }}>Mission Continuity</h3>
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Autonomous edge operations must continue even when disconnected, while preserving mission intent.
        </p>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Key Capabilities for Dual-Use Readiness */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Key Capabilities for Dual-Use Readiness
      </h2>
      <p className="text-base md:text-lg max-w-3xl mx-auto" style={{ color: '#9CA3AF' }}>
        Mission-critical capabilities designed for defense operations and applicable to civil infrastructure protection.
      </p>
    </div>
    
    {/* Three Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      
      {/* Field Resilience */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <path d="M12 2L4 6v6c0 5.5 3.4 10.6 8 12 4.6-1.4 8-6.5 8-12V6l-8-4z" />
          </svg>
          <h3 className="text-xl md:text-2xl font-bold" style={{ color: '#E8EDDF' }}>Field Resilience</h3>
        </div>
        
        {/* List */}
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Decentralized logic execution at the edge</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Autonomous operation when disconnected from command</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Byzantine fault tolerance for contested environments</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Graceful degradation under network partition</span>
          </li>
        </ul>
      </div>
      
      {/* Interoperability */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <rect x="2" y="6" width="6" height="6" rx="1" />
            <rect x="16" y="6" width="6" height="6" rx="1" />
            <rect x="9" y="14" width="6" height="6" rx="1" />
            <line x1="5" y1="12" x2="5" y2="17" />
            <line x1="5" y1="17" x2="9" y2="17" />
            <line x1="19" y1="12" x2="19" y2="17" />
            <line x1="19" y1="17" x2="15" y2="17" />
          </svg>
          <h3 className="text-xl md:text-2xl font-bold" style={{ color: '#E8EDDF' }}>Interoperability</h3>
        </div>
        
        {/* List */}
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Orchestration across legacy military and commercial systems</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Unified data exchange layer for heterogeneous assets</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Protocol adapters for defense standards (Link 16, DDS, MQTT)</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Multi-domain coordination (air, land, sea, cyber, space)</span>
          </li>
        </ul>
      </div>
      
      {/* Compliance & Trust */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
          <h3 className="text-xl md:text-2xl font-bold" style={{ color: '#E8EDDF' }}>Compliance & Trust</h3>
        </div>
        
        {/* List */}
        <ul className="space-y-4">
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Complete auditability of orchestration decisions</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Role-based access control with principle of least privilege</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Separation of classified and unclassified data flows</span>
          </li>
          <li className="flex items-start gap-3">
            <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#4FB3B8" strokeWidth="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
            <span className="text-sm" style={{ color: '#9CA3AF' }}>Digital sovereignty with on-premises deployment options</span>
          </li>
        </ul>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Use Case 1 — Remote Maintenance & Sustainment */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header - Left Aligned */}
    <div className="mb-12">
      <div 
        className="inline-flex items-center px-3 py-1.5 rounded-md text-xs font-bold tracking-wider mb-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#9CA3AF' }}
      >
        USE CASE 1
      </div>
      
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3" style={{ color: '#E8EDDF' }}>
        Remote Maintenance & Sustainment
      </h2>
      
      <p className="text-xl md:text-2xl font-medium" style={{ color: '#F5CB5C' }}>
        Ensuring Near-Zero Downtime for Critical Assets
      </p>
    </div>
    
    {/* Two Application Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      
      {/* Defense Application */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#9CA3AF' }}>DEFENSE APPLICATION</span>
        
        <h3 className="text-lg font-bold mt-3 mb-4" style={{ color: '#E8EDDF' }}>
          Remote Sustainment of Forward-Deployed Assets
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Maintain operational readiness of platforms deployed in remote or contested areas where physical maintenance access is limited or dangerous.
        </p>
      </div>
      
      {/* Civil Application */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#9CA3AF' }}>CIVIL APPLICATION</span>
        
        <h3 className="text-lg font-bold mt-3 mb-4" style={{ color: '#E8EDDF' }}>
          Predictive Maintenance of Critical National Infrastructure
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Monitor and maintain power grids, water systems, and transportation infrastructure with predictive diagnostics and remote intervention.
        </p>
      </div>
      
    </div>
    
    {/* Sleeve Advantage Card */}
    <div 
      className="rounded-xl p-8 mb-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <h3 className="text-2xl md:text-3xl font-bold mb-8" style={{ color: '#E8EDDF' }}>
        Sleeve Advantage
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Collaborative Diagnostics */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Collaborative Diagnostics</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Diagnostic agents deployed at the edge perform automated multi-step analysis, escalating to human experts only when necessary.
          </p>
        </div>
        
        {/* Reduced Logistics Burden */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Reduced Logistics Burden</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Remote troubleshooting eliminates unnecessary travel and parts shipments. Physical intervention only when confirmed necessary.
          </p>
        </div>
        
        {/* Increased Availability */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Increased Availability</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Faster time-to-repair through parallel diagnostics and proactive maintenance scheduling increases operational availability.
          </p>
        </div>
        
      </div>
    </div>
    
    {/* Stats Row */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
      
      {/* 75% */}
      <div>
        <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#E8EDDF' }}>75%</p>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>Reduction in unnecessary site visits</p>
      </div>
      
      {/* 3-5x */}
      <div>
        <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#E8EDDF' }}>3-5x</p>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>Faster diagnostic resolution</p>
      </div>
      
      {/* 95%+ */}
      <div>
        <p className="text-4xl md:text-5xl font-bold mb-2" style={{ color: '#E8EDDF' }}>95%+</p>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>Asset operational availability</p>
      </div>
      
    </div>
    
  </div>
</section>


      {/* Use Case 2 — Automated Agent Orchestration */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header - Left Aligned */}
    <div className="mb-12">
      <div 
        className="inline-flex items-center px-3 py-1.5 rounded-md text-xs font-bold tracking-wider mb-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#9CA3AF' }}
      >
        USE CASE 2
      </div>
      
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3" style={{ color: '#E8EDDF' }}>
        Automated Agent Orchestration
      </h2>
      
      <p className="text-xl md:text-2xl font-medium" style={{ color: '#F5CB5C' }}>
        Coordinating Multi-Domain & Multi-Agency Response
      </p>
    </div>
    
    {/* Two Application Cards */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
      
      {/* Defense Application */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#9CA3AF' }}>DEFENSE APPLICATION</span>
        
        <h3 className="text-lg font-bold mt-3 mb-4" style={{ color: '#E8EDDF' }}>
          Multi-Domain Operations (MDO)
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Coordinate air, sea, land, cyber, and space assets in unified operations. Dynamic coalition formation and real-time coordination across domains.
        </p>
      </div>
      
      {/* Civil Application */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        <span className="text-xs font-bold tracking-wider" style={{ color: '#9CA3AF' }}>CIVIL APPLICATION</span>
        
        <h3 className="text-lg font-bold mt-3 mb-4" style={{ color: '#E8EDDF' }}>
          Disaster Response Coordination
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Orchestrate police, fire, EMS, utilities, and other agencies during natural disasters or emergencies requiring multi-agency coordination.
        </p>
      </div>
      
    </div>
    
    {/* Orchestration Diagram Card */}
    <div 
      className="rounded-xl p-8 mb-6"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <svg width="100%" height="320" viewBox="0 0 800 320" className="max-w-full">
        
        {/* Top Row - 5 Domain Boxes */}
        
        {/* AIR ASSETS */}
        <rect x="80" y="30" width="100" height="50" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <text x="130" y="52" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">AIR ASSETS</text>
        <text x="130" y="68" textAnchor="middle" fill="#9CA3AF" fontSize="8">ISR / Transport</text>
        
        {/* LAND FORCES */}
        <rect x="200" y="30" width="100" height="50" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <text x="250" y="52" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">LAND FORCES</text>
        <text x="250" y="68" textAnchor="middle" fill="#9CA3AF" fontSize="8">Ground Units</text>
        
        {/* SEA PLATFORMS */}
        <rect x="320" y="30" width="100" height="50" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <text x="370" y="52" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">SEA PLATFORMS</text>
        <text x="370" y="68" textAnchor="middle" fill="#9CA3AF" fontSize="8">Naval Assets</text>
        
        {/* CYBER OPS */}
        <rect x="440" y="30" width="100" height="50" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <text x="490" y="52" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">CYBER OPS</text>
        <text x="490" y="68" textAnchor="middle" fill="#9CA3AF" fontSize="8">Network Defense</text>
        
        {/* SPACE */}
        <rect x="560" y="30" width="100" height="50" rx="4" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <text x="610" y="52" textAnchor="middle" fill="#E8EDDF" fontSize="10" fontWeight="600">SPACE</text>
        <text x="610" y="68" textAnchor="middle" fill="#9CA3AF" fontSize="8">Satellite Comms</text>
        
        {/* Connecting Lines from domains to SLEEVE ORCHESTRATION */}
        <line x1="130" y1="80" x2="130" y2="100" stroke="#3A3A38" strokeWidth="1" />
        <line x1="130" y1="100" x2="250" y2="130" stroke="#3A3A38" strokeWidth="1" />
        
        <line x1="250" y1="80" x2="250" y2="100" stroke="#3A3A38" strokeWidth="1" />
        <line x1="250" y1="100" x2="310" y2="130" stroke="#3A3A38" strokeWidth="1" />
        
        <line x1="370" y1="80" x2="370" y2="130" stroke="#3A3A38" strokeWidth="1" />
        
        <line x1="490" y1="80" x2="490" y2="100" stroke="#3A3A38" strokeWidth="1" />
        <line x1="490" y1="100" x2="430" y2="130" stroke="#3A3A38" strokeWidth="1" />
        
        <line x1="610" y1="80" x2="610" y2="100" stroke="#3A3A38" strokeWidth="1" />
        <line x1="610" y1="100" x2="490" y2="130" stroke="#3A3A38" strokeWidth="1" />
        
        {/* SLEEVE ORCHESTRATION Box */}
        <rect x="220" y="130" width="300" height="70" rx="6" fill="#242423" stroke="#F5CB5C" strokeWidth="1.5" />
        <text x="370" y="155" textAnchor="middle" fill="#E8EDDF" fontSize="12" fontWeight="700">SLEEVE ORCHESTRATION</text>
        <text x="370" y="175" textAnchor="middle" fill="#9CA3AF" fontSize="9">Intent Exchange • Dynamic Coalition • Coordinated Action</text>
        <text x="370" y="190" textAnchor="middle" fill="#9CA3AF" fontSize="8">Agents share intent and situational awareness, not just raw data</text>
        
        {/* Dashed line from SLEEVE to SHARED SITUATIONAL AWARENESS */}
        <line x1="370" y1="200" x2="370" y2="240" stroke="#3A3A38" strokeWidth="1.5" strokeDasharray="5 3" />
        
        {/* SHARED SITUATIONAL AWARENESS Box */}
        <rect x="220" y="240" width="300" height="55" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" strokeDasharray="5 3" />
        <text x="370" y="265" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">SHARED SITUATIONAL AWARENESS</text>
        <text x="370" y="282" textAnchor="middle" fill="#9CA3AF" fontSize="8">Common Operating Picture • Real-Time Updates</text>
        
      </svg>
    </div>
    
    {/* Sleeve Advantage Card */}
    <div 
      className="rounded-xl p-8"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <h3 className="text-2xl md:text-3xl font-bold mb-8" style={{ color: '#E8EDDF' }}>
        Sleeve Advantage
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Dynamic Coalition Formation */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Dynamic Coalition Formation</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Assets join and leave operational groups dynamically. Coordination adapts in real-time to changing mission requirements.
          </p>
        </div>
        
        {/* Intent-Based Exchange */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Intent-Based Exchange</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Agents share intent and objectives, not just sensor data. Enables autonomous coordination toward mission goals.
          </p>
        </div>
        
        {/* Reduced Human Latency */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Reduced Human Latency</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Routine coordination decisions executed autonomously. Human oversight retained for critical strategic decisions.
          </p>
        </div>
        
      </div>
    </div>
    
  </div>
</section>
      {/* Use Case 3 — Cybersecurity Detection & Response */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header - Left Aligned */}
    <div className="mb-12">
      <div 
        className="inline-flex items-center px-3 py-1.5 rounded-md text-xs font-bold tracking-wider mb-6"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38', color: '#9CA3AF' }}
      >
        USE CASE 3
      </div>
      
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3" style={{ color: '#E8EDDF' }}>
        Cybersecurity Detection & Response
      </h2>
      
      <p className="text-xl md:text-2xl font-medium" style={{ color: '#F5CB5C' }}>
        Protecting the Operational Technology Edge
      </p>
    </div>
    
    {/* The OT Security Challenge Card */}
    <div 
      className="rounded-xl p-8 mb-6"
      style={{ backgroundColor: '#2E2E2C', border: '2px dashed #3A3A38' }}
    >
      <h3 className="text-xl font-bold mb-6" style={{ color: '#E8EDDF' }}>
        The OT Security Challenge
      </h3>
      
      <ul className="space-y-4">
        <li className="flex items-start gap-3">
          <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span className="text-sm" style={{ color: '#9CA3AF' }}>Edge systems are prime attack vectors in cyber-physical domains</span>
        </li>
        <li className="flex items-start gap-3">
          <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span className="text-sm" style={{ color: '#9CA3AF' }}>IT security tools designed for enterprise networks are too slow or disruptive for OT</span>
        </li>
        <li className="flex items-start gap-3">
          <svg className="w-5 h-5 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="none" stroke="#FF6B6B" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span className="text-sm" style={{ color: '#9CA3AF' }}>Detection without coordinated response leaves systems vulnerable</span>
        </li>
      </ul>
    </div>
    
    {/* Sleeve Advantage: Orchestrated Defense Card */}
    <div 
      className="rounded-xl p-8 mb-6"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <h3 className="text-xl font-bold mb-6" style={{ color: '#E8EDDF' }}>
        Sleeve Advantage: Orchestrated Defense
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Embedded Edge Detection */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Embedded Edge Detection</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Anomaly detection agents run at the edge, identifying threats in real-time without centralized bottlenecks.
          </p>
        </div>
        
        {/* Orchestrated Isolation */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Orchestrated Isolation</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Compromised subsystems isolated automatically. Unaffected assets continue mission-critical operations.
          </p>
        </div>
        
        {/* Standards Alignment */}
        <div>
          <h4 className="text-sm font-bold mb-3" style={{ color: '#E8EDDF' }}>Standards Alignment</h4>
          <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
            Security architecture aligned with IEC 62443 for OT cybersecurity and NIST frameworks for defense systems.
          </p>
        </div>
        
      </div>
    </div>
    
    {/* Normal vs Degraded Diagram Card */}
    <div 
      className="rounded-xl p-8 mb-12"
      style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
    >
      <svg width="100%" height="320" viewBox="0 0 900 320" className="max-w-full">
        
        {/* ===== NORMAL SIDE ===== */}
        
        {/* NORMAL Badge */}
        <rect x="175" y="15" width="70" height="24" rx="4" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
        <text x="210" y="32" textAnchor="middle" fill="#4FB3B8" fontSize="10" fontWeight="600">NORMAL</text>
        
        {/* COMMAND HQ Box */}
        <rect x="110" y="55" width="200" height="55" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
        <g transform="translate(195, 68)">
          <path d="M5 12 C5 6, 10 2, 15 2 C20 2, 25 6, 25 12" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <line x1="15" y1="12" x2="15" y2="18" stroke="#4FB3B8" strokeWidth="1.5" />
        </g>
        <text x="210" y="90" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">COMMAND HQ</text>
        <text x="210" y="104" textAnchor="middle" fill="#9CA3AF" fontSize="8">Full Connectivity</text>
        
        {/* Three connecting lines */}
        <line x1="170" y1="110" x2="170" y2="160" stroke="#4FB3B8" strokeWidth="2" />
        <line x1="210" y1="110" x2="210" y2="160" stroke="#4FB3B8" strokeWidth="2" />
        <line x1="250" y1="110" x2="250" y2="160" stroke="#4FB3B8" strokeWidth="2" />
        
        {/* SUB A */}
        <rect x="110" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
        <g transform="translate(140, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#4FB3B8" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#4FB3B8" strokeWidth="1" />
        </g>
        <text x="150" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB A</text>
        <text x="150" y="218" textAnchor="middle" fill="#4FB3B8" fontSize="7">● ONLINE</text>
        
        {/* SUB B */}
        <rect x="200" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
        <g transform="translate(230, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#4FB3B8" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#4FB3B8" strokeWidth="1" />
        </g>
        <text x="240" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB B</text>
        <text x="240" y="218" textAnchor="middle" fill="#4FB3B8" fontSize="7">● ONLINE</text>
        
        {/* SUB C */}
        <rect x="290" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#4FB3B8" strokeWidth="1.5" />
        <g transform="translate(320, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#4FB3B8" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#4FB3B8" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#4FB3B8" strokeWidth="1" />
        </g>
        <text x="330" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB C</text>
        <text x="330" y="218" textAnchor="middle" fill="#4FB3B8" fontSize="7">● ONLINE</text>
        
        {/* 100% Operational */}
        <text x="240" y="255" textAnchor="middle" fill="#9CA3AF" fontSize="10">100% Operational</text>
        
        {/* ===== DEGRADED SIDE ===== */}
        
        {/* DEGRADED Badge */}
        <rect x="605" y="15" width="80" height="24" rx="4" fill="#FF6B6B" />
        <text x="645" y="32" textAnchor="middle" fill="#242423" fontSize="10" fontWeight="600">DEGRADED</text>
        
        {/* COMMAND HQ Box (degraded) */}
        <rect x="545" y="55" width="200" height="55" rx="6" fill="rgba(255, 107, 107, 0.15)" stroke="#FF6B6B" strokeWidth="1.5" />
        <g transform="translate(630, 68)">
          <path d="M5 12 C5 6, 10 2, 15 2 C20 2, 25 6, 25 12" fill="none" stroke="#FF6B6B" strokeWidth="1.5" />
          <line x1="15" y1="12" x2="15" y2="18" stroke="#FF6B6B" strokeWidth="1.5" />
        </g>
        <text x="645" y="90" textAnchor="middle" fill="#E8EDDF" fontSize="11" fontWeight="600">COMMAND HQ</text>
        <text x="645" y="104" textAnchor="middle" fill="#FF6B6B" fontSize="8">⚠ Link Severed</text>
        
        {/* Broken/dashed connecting lines */}
        <line x1="605" y1="110" x2="605" y2="130" stroke="#3A3A38" strokeWidth="2" strokeDasharray="4 3" />
        <line x1="645" y1="110" x2="645" y2="130" stroke="#3A3A38" strokeWidth="2" strokeDasharray="4 3" />
        <line x1="685" y1="110" x2="685" y2="130" stroke="#3A3A38" strokeWidth="2" strokeDasharray="4 3" />
        
        {/* X marks on broken lines */}
        <text x="605" y="145" textAnchor="middle" fill="#FF6B6B" fontSize="12">✕</text>
        <text x="645" y="145" textAnchor="middle" fill="#FF6B6B" fontSize="12">✕</text>
        <text x="685" y="145" textAnchor="middle" fill="#FF6B6B" fontSize="12">✕</text>
        
        {/* SUB A (auto) */}
        <rect x="545" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <g transform="translate(575, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#9CA3AF" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#9CA3AF" strokeWidth="1" />
        </g>
        <text x="585" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB A</text>
        <text x="585" y="218" textAnchor="middle" fill="#F5CB5C" fontSize="7">● AUTO</text>
        
        {/* SUB B (auto) */}
        <rect x="635" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <g transform="translate(665, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#9CA3AF" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#9CA3AF" strokeWidth="1" />
        </g>
        <text x="675" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB B</text>
        <text x="675" y="218" textAnchor="middle" fill="#F5CB5C" fontSize="7">● AUTO</text>
        
        {/* SUB C (auto) */}
        <rect x="725" y="165" width="80" height="55" rx="6" fill="#242423" stroke="#3A3A38" strokeWidth="1.5" />
        <g transform="translate(755, 178)">
          <rect x="0" y="0" width="20" height="14" rx="2" fill="none" stroke="#9CA3AF" strokeWidth="1.5" />
          <line x1="5" y1="5" x2="15" y2="5" stroke="#9CA3AF" strokeWidth="1" />
          <line x1="5" y1="9" x2="15" y2="9" stroke="#9CA3AF" strokeWidth="1" />
        </g>
        <text x="765" y="207" textAnchor="middle" fill="#E8EDDF" fontSize="9" fontWeight="600">SUB C</text>
        <text x="765" y="218" textAnchor="middle" fill="#F5CB5C" fontSize="7">● AUTO</text>
        
        {/* 75% Mission Capability Bar */}
        <rect x="545" y="245" width="260" height="40" rx="6" fill="rgba(255, 107, 107, 0.2)" stroke="#FF6B6B" strokeWidth="1" />
        <text x="675" y="263" textAnchor="middle" fill="#FF6B6B" fontSize="11" fontWeight="600">75% Mission Capability</text>
        <text x="675" y="278" textAnchor="middle" fill="#9CA3AF" fontSize="8">Autonomous coordination maintained</text>
        
      </svg>
    </div>
    
    {/* Bottom Stats Row */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
      
      {/* Network Resilience */}
      <div>
        <h4 className="text-lg font-bold mb-2" style={{ color: '#E8EDDF' }}>Network Resilience</h4>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>Contained threats don't propagate</p>
      </div>
      
      {/* Mission Continuity */}
      <div>
        <h4 className="text-lg font-bold mb-2" style={{ color: '#E8EDDF' }}>Mission Continuity</h4>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>Unaffected systems operate normally</p>
      </div>
      
      {/* Standards Aligned */}
      <div>
        <h4 className="text-lg font-bold mb-2" style={{ color: '#E8EDDF' }}>Standards Aligned</h4>
        <p className="text-sm" style={{ color: '#9CA3AF' }}>IEC 62443 & NIST compliant</p>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Why Sleeve for Dual-Use Systems */}
<section className="py-24 md:py-32 px-4 md:px-6 lg:px-8" style={{ backgroundColor: '#242423' }}>
  <div className="max-w-7xl mx-auto">
    
    {/* Header */}
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#E8EDDF' }}>
        Why Sleeve for Dual-Use Systems
      </h2>
      <p className="text-base md:text-lg" style={{ color: '#9CA3AF' }}>
        Cross-cutting strengths designed for mission-critical operations.
      </p>
    </div>
    
    {/* Three Cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      
      {/* Human-in-the-Loop Control */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div className="mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <path d="M12 2 L8 10 L16 10 Z" />
            <line x1="12" y1="10" x2="12" y2="22" />
          </svg>
        </div>
        
        <h3 className="text-lg font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Human-in-the-Loop Control
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Critical strategic decisions remain under human authority. Autonomous execution limited to routine operations within defined policy boundaries.
        </p>
      </div>
      
      {/* Decentralized with Centralized Intent */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div className="mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <circle cx="12" cy="6" r="3" />
            <circle cx="6" cy="18" r="3" />
            <circle cx="18" cy="18" r="3" />
            <line x1="12" y1="9" x2="6" y2="15" />
            <line x1="12" y1="9" x2="18" y2="15" />
          </svg>
        </div>
        
        <h3 className="text-lg font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Decentralized with Centralized Intent
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Edge nodes operate autonomously when disconnected, yet maintain coherence with centralized mission intent and strategic objectives.
        </p>
      </div>
      
      {/* Auditability & Governance */}
      <div 
        className="rounded-xl p-8"
        style={{ backgroundColor: '#2E2E2C', border: '1px solid #3A3A38' }}
      >
        {/* Icon */}
        <div className="mb-6">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.5">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
        
        <h3 className="text-lg font-bold mb-4" style={{ color: '#E8EDDF' }}>
          Auditability & Governance
        </h3>
        
        <p className="text-sm leading-relaxed" style={{ color: '#9CA3AF' }}>
          Complete audit trail of orchestration decisions. Role-based access control and separation of data classifications built into the platform.
        </p>
      </div>
      
    </div>
    
  </div>
</section>

      {/* Final CTA */}
      <section className="py-24 md:py-32 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-foreground mb-6">
            Request a Confidential Technical Briefing
          </h2>
          
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed mb-6 max-w-2xl mx-auto">
            Discuss how Sleeve enables interoperable, resilient system-of-systems coordination for defense and dual-use applications.
          </p>
          
          <div className="flex flex-wrap gap-4 justify-center items-center mb-8">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Check" size={16} color="var(--color-accent)" />
              <span>Field resilience</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Check" size={16} color="var(--color-accent)" />
              <span>Multi-domain interoperability</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Check" size={16} color="var(--color-accent)" />
              <span>Digital sovereignty</span>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors text-lg"
            >
              Request a Confidential Briefing
              <Icon name="ArrowRight" size={20} />
            </Link>
            <Link 
              to="/use-cases" 
              className="inline-flex items-center gap-2 px-8 py-4 bg-card border border-border text-foreground rounded-lg font-medium hover:bg-card/80 transition-colors text-lg"
            >
              View All Use Cases
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DefenseDualUseUseCaseDetail;